import { helper as buildHelper } from '@ember/component/helper';
import { convertNewLinesToBRs } from "../utils/misc";

/**
 * Given text, convert any newline characters to <br>s and return the string.
 *
 * @param params
 * @return {String}
 */
export function convertNewlineToBr(params/*, hash*/) {
  let text = params[0];
  return convertNewLinesToBRs(text);
}

export default buildHelper(convertNewlineToBr);
